import { render, staticRenderFns } from "./WordCloudShape.vue?vue&type=template&id=14082063&"
import script from "./WordCloudShape.vue?vue&type=script&lang=ts&"
export * from "./WordCloudShape.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports